import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const LegalPage = ({ title, slug, lastUpdated, children }) => {
  const [pageData, setPageData] = useState(null);
  const [loading, setLoading] = useState(!!slug);

  useEffect(() => {
    if (slug) {
      fetchPageContent();
    }
  }, [slug]);

  const fetchPageContent = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/pages/${slug}/full`);
      if (response.data && response.data.content) {
        setPageData(response.data);
      }
    } catch (error) {
      // Use default children content if API fails
      console.log(`Using default content for ${slug}`);
    } finally {
      setLoading(false);
    }
  };

  // Set document title using useEffect
  useEffect(() => {
    const displayTitle = pageData?.title || title || 'Legal';
    const metaTitle = pageData?.meta_title || `${displayTitle} | Indicraft`;
    document.title = metaTitle;
  }, [pageData, title]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex flex-col">
        <Header />
        <main className="flex-grow flex items-center justify-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-[#064E3B]"></div>
        </main>
        <Footer />
      </div>
    );
  }

  const displayTitle = pageData?.title || title || 'Legal';

  return (
    <div className="min-h-screen bg-white flex flex-col">
      <Header />
      
      <main className="flex-grow">
        <div className="bg-gradient-to-b from-white to-[#F8FAFC] py-16">
          <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="bg-white rounded-2xl shadow-sm border border-zinc-200 p-8 md:p-12">
              <h1 className="text-3xl md:text-4xl font-bold text-[#0f172a] mb-3" data-testid="legal-page-title">
                {displayTitle}
              </h1>
              <p className="text-sm text-zinc-500 mb-8">Last Updated: {lastUpdated || new Date().toLocaleDateString('en-IN', { month: 'long', year: 'numeric' })}</p>
              
              {pageData?.content ? (
                <div 
                  className="prose prose-zinc max-w-none prose-headings:text-[#0f172a] prose-h2:text-2xl prose-h3:text-xl prose-p:text-zinc-600 prose-p:leading-relaxed prose-li:text-zinc-600"
                  dangerouslySetInnerHTML={{ __html: pageData.content }}
                  data-testid="legal-page-content"
                />
              ) : (
                <div className="prose prose-zinc max-w-none" data-testid="legal-page-content">
                  {children}
                </div>
              )}
            </div>
          </div>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default LegalPage;
